<template>
  <div id="app">
    <router-view />
    <audio controls ref="audio" class="audio">
      <source src="../static/notice.mp3" />
    </audio>
  </div>
</template>

<script>
import { adminOrderApi } from '@/api/adminOrder.js'
export default {
  name: 'App',
  data() {
    return {
      timer: null
    }
  },
  mounted() {
    if (systemParams.getMaxOrderId === 1) {
      this.getMaxOrderIdMethod()
    }
  },
  methods: {
    getMaxOrderIdMethod() {
      let that = this
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.timer = setInterval(() => {
        adminOrderApi.getMaxOrderId().then(res => {
          if (res.data.code == 1) {
            let id = res.data.data
            let localId = window.localStorage.getItem('maxOrderld')
            if (localId) {
              if (Number(id) > Number(localId)) {
                window.localStorage.setItem('maxOrderld', id);
                that.$refs.audio.play();
              }
            } else {
              window.localStorage.setItem('maxOrderld', id);
            }
          }
        })
      }, 1000 * 10)
    },
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  background: #EFF1F4;
}
.audio {
  position: fixed;
  top: -110%;
  left: -120%;
}
</style>
